'use client';
import NumberFormatter from '@/utils/bn';
import { useEffect, useState } from 'react';

type CountdownTimerProps = {
  secondsLeft: number;
};

export function formatTime(timeLeft: number) {
  const days = Math.floor(timeLeft / (60 * 60 * 24));
  const hours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((timeLeft % (60 * 60)) / 60);
  const seconds = Math.floor(timeLeft % 60);

  const formattedDays = NumberFormatter(days);
  const formattedHours = NumberFormatter(hours);
  const formattedMinutes = NumberFormatter(minutes);
  const formattedSeconds = NumberFormatter(seconds);

  if (days > 0) {
    return `${formattedDays} দিন`;
  } else if (hours > 0) {
    return `${formattedHours} ঘ.`;
  } else if (minutes > 0) {
    return `${formattedMinutes} মি.`;
  } else {
    return `${formattedSeconds} সে.`;
  }
}

function CountdownTimer({ secondsLeft }: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(secondsLeft);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    const timerId = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 0) {
          clearInterval(timerId);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  const formattedTime = formatTime(timeLeft);

  return (
    <>
      {isClient && (
        <>
          <span className="hidden text-sm font-semibold md:inline lg:text-base">
            {formattedTime}
          </span>
          <span className="text-sm md:hidden lg:text-base ">
            {formattedTime}
          </span>
        </>
      )}
    </>
  );
}

export default CountdownTimer;
